import Tippy from "@tippyjs/react";
import $ from "jquery";
import { default as Moment, default as moment } from "moment";
import { useContext, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "tippy.js/dist/tippy.css";
import { ConfigContext } from "../../App";
import Breadcrumb from "../../components/Breadcrumb";
import Pagination from "../../components/Pagination";
import Header from "../../components/partials/Header";
import Sidebar from "../../components/partials/Sidebar";
import config, { config2 } from "../../config";
import deleteIcon from "../../images/icons/delete.png";
import editIcon from "../../images/icons/edit.png";
import filter from "../../images/icons/filter.png";
import resendIcon from "../../images/icons/resend.png";
import viewIcon from "../../images/icons/view.png";
import { millionComma, userBackDate } from "../../utils";
import { formatAmountChallan } from "../Purchase/util";
import "./style.css";
import { formatStatusBadge } from "./util";
import { FaShare } from "react-icons/fa";

function TempSalesList(props) {
  const location = useLocation();

  const [user, setUser] = useState({});

  const noPricePrint = useContext(ConfigContext).noPricePrint;
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const initialState = {
    challan_no: "",
    challan_id: "",
    customer_name: "",
    branch_name: "",
    branch_id: "",
    from_date: "",
    to_date: "",
    is_active: "",
    payment_mode_id: "",
    is_zero_value: "",
    page_size: 10,
  };

  let newFilter = location.state?.appliedFilter || initialState;
  let newFilterVisiblity = location.state?.filterDisplay;
  let backToCurrPage = location.state?.backToCurrent;

  const [formInputs, setFormInputs] = useState(newFilter);
  const [showPageLoader, setShowPageLoader] = useState(false);
  const [filtersVisible, setFiltersVisible] = useState(
    newFilterVisiblity === true ? true : false
  );
  const [filterActive, setFilterActive] = useState(
    location.state?.appliedFilter ? true : false
  );
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isExport, setIsExport] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    backToCurrPage ? backToCurrPage : 1
  );

  const initialPageSize = location.state?.pageSize || 10;
  const [userCount, setUserCount] = useState(initialPageSize);
  const [totalPage, setTotalPage] = useState(0);
  const [filterDate, setFilterDate] = useState();
  let dates = filterDate && JSON.parse(filterDate.date);
  const [frezzLoader, setFrezzLoader] = useState(null);

  function handleInputDate(e) {
    setFilterDate((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  }

  function toggleItemDetail(id) {
    $(`#${id}`).is(":visible")
      ? $(`#${id}`).addClass("d-none")
      : $(`#${id}`).removeClass("d-none");
  }

  function changeStatus(challan_id, is_active) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;
    setFrezzLoader(challan_id);

    confirmAlert({
      title: "Are you sure?",
      message: `You want to ${is_active == 3 ? "unfreeze" : "cancel"} challan.`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            $.post(
              `${config.apiUrl}/challan/cancelChallan`,
              JSON.stringify({
                branch_id,
                challan_id,
                is_active,
                is_temp: true,
              })
            )
              .done(function (res) {
                getList(filtersVisible);
                setError("");
                setSuccess(res?.data?.message);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
                setFrezzLoader(null);
              })
              .catch(function (err) {
                setSuccess("");
                setFrezzLoader(null);
                setError(
                  err?.responseJSON?.data?.message || err?.responseJSON?.message
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              });
          },
        },
        {
          label: "No",
          onClick: () => {
            setFrezzLoader(null);
          },
        },
      ],
    });
  }

  function convertStatus(challan_id) {
    const userData = JSON.parse(localStorage.getItem("inventory"))?.userData;
    const branch_id = userData?.branch_data?.[0]?.branch_id;

    confirmAlert({
      title: "Are you sure?",
      message: `You want to process challan.`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            $.post(
              `${config.apiUrl}/challan/convertTempChallan`,
              JSON.stringify({
                challan_id,
                branch_id,
                is_temp: true,
              })
            )
              .done(function (res) {
                getList(filtersVisible);
                setError("");
                setSuccess(res?.data?.message);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setSuccess("");
                setError(
                  err?.responseJSON?.data?.message || err?.responseJSON?.message
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  async function getList(isFilter = true, pageNo = null, perPage = userCount) {
    let json = {
      paginate: 1,
      page_no: (pageNo || currentPage) - 1,
      branch_id: JSON.parse(localStorage.getItem("inventory"))?.userData
        ?.branch_data?.[0]?.branch_id,
      list_type: 3,
      // created_by:JSON.parse(localStorage.getItem("inventory")).userData
      //                     ?.role_id
    };
    if (isFilter) {
      // if (dates) {
      //   formInputs.from_date = dates[0];
      //   formInputs.to_date = dates[1];
      // }
      json = {
        ...json,
        ...formInputs,
        branch_id:
          JSON.parse(localStorage.getItem("inventory"))?.userData
            ?.branch_data?.[0]?.branch_id || formInputs.branch_id,
      };
    }
    json.page_size = perPage;
    json.is_temp = true;
    await $.post(
      `${config2.apiUrl}/challan/listTempChallan`,
      JSON.stringify(json)
    )
      .done(function (res) {
        setCurrentPage(pageNo || currentPage);
        setList(res?.data?.list || []);
        setTotalPage(res?.data?.count || 0);
        setIsLoading(false);
        setIsSubmit(false);
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  useEffect(
    function () {
      getList(filterActive);
    },
    [currentPage]
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  // async function getList(isFilter = true, pageNo = null) {
  //   let json = {
  //     paginate: 1,
  //     page_no: (pageNo || currentPage) - 1,
  //     branch_id: JSON.parse(localStorage.getItem("inventory"))?.userData
  //       ?.branch_data?.[0]?.branch_id,
  //     list_type: 3,
  //   };
  //   if (isFilter) {
  //     json = { ...json, ...formInputs };
  //   }
  //   await $.post(`${config.apiUrl}/challan/listChallan`, JSON.stringify(json))
  //     .done(function (res) {
  //       setCurrentPage(pageNo || currentPage);
  //       setList(res?.data?.list || []);
  //       setTotalPage(res?.data?.count || 0);
  //       setIsLoading(false);
  //       setIsSubmit(false);
  //     })
  //     .catch(function (err) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
  //         confirmButtonText: "OK",
  //         allowEnterKey: false,
  //         allowEscapeKey: false,
  //         allowOutsideClick: false,
  //         focusConfirm: true,
  //       });
  //     });
  // }

  const [exportIds, setExportIds] = useState([]);
  const getExportIds = (e) => {
    if (e.target.value == "All") {
      if (e.target.checked) {
        if (
          moment(formInputs.challan_date).format("MM-DD-yy") >=
          moment().format("MM-DD-yy")
        ) {
          setExportIds((prevState) => [
            ...prevState,
            ...list
              .map((v) =>
                v.is_zero_value == 0 &&
                (v.is_active == 4 ||
                  v.is_active == 3 ||
                  v.is_active == 2 ||
                  v.is_active == 6)
                  ? v.challan_id
                  : ""
              )
              .filter(Boolean),
          ]);
        } else {
          setExportIds((prevState) => [
            ...prevState,
            ...list
              .map((v) =>
                v.is_zero_value == 0 && v.is_active == 4 ? v.challan_id : ""
              )
              .filter(Boolean),
          ]);
        }
      } else {
        setExportIds(() => []);
      }
    } else {
      const val = e.target.value;
      if (e.target.checked) {
        setExportIds((prevState) => [...prevState, val.match(/^\d+$/) ? Number(val) : val]);
      } else {
        setExportIds((prevState) =>
          prevState.filter((v) => v != val)
        );
      }
    }
  };
  const downloadExportJson = async () => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one challan");
      return;
    }
    let branch_id =
      JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]
        ?.branch_id || formInputs.branch_id;
    setIsExport(true);
    await $.post(
      `${config.apiUrl}/challan/exportChallan`,
      JSON.stringify({
        challan_ids: exportIds,
        branch_id: branch_id,
        is_temp: true,
      })
    )
      .done(function (res) {
        const jsonData = new Blob([JSON.stringify(res, null, 3)], {
          type: "text/json",
        });
        const jsonURL = window.URL.createObjectURL(jsonData);
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = jsonURL;
        link.setAttribute("download", "Pending-Challan.json");
        link.click();
        document.body.removeChild(link);
        setIsExport(false);
        getList(filterActive);
      })
      .catch(function (err) {
        setIsExport(false);
      });
  };

  //   useEffect(() => {
  //     const interval = setInterval(() => , 1000);
  //     return () => {
  //       clearInterval(interval);
  //     };
  //   }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      getList();
    }, 60000);

    return () => {
      clearTimeout(timer);
    };
  });
  const changePageSize = async (e) => {
    setUserCount(() => e.target.value);
    // setFormInputs((prevState) => {
    //   return { ...prevState, page_size: e.target.value };
    // });
    if (list.length > 0) {
      currentPage == 1
        ? await getList(
            {
              ...formInputs,
              // page_size: e.target.value,
            },
            null,
            e.target.value
          )
        : setCurrentPage(() => 1);
    }
  };
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <div
          id="page-loader"
          style={{
            display: showPageLoader !== false ? "block" : "none",
            width: "100%",
            height: "100%",
            position: "fixed",
            background: "black",
            opacity: ".5",
            zIndex: "1000",
            textAlign: "center",
            color: "white",
            fontSize: "16px",
            fontWeight: "bold",
            paddingTop: "200px",
          }}
        >
          {showPageLoader}
        </div>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />

          <main className="bg-white rounded-4" id="sale">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Challan"]} />
                </div>
                <div className="col text-end">
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      //   alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>
                  <span className=" me-3">
                    <label className="me-1">Per Page</label>
                    <select
                      value={userCount}
                      onChange={(e) => changePageSize(e)}
                      className="custom-select"
                      style={{
                        height: "32px",
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    setFilterActive(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  id="saleAdd"
                  className="my-3"
                  autoComplete="off"
                >
                  <div className="row g-3 mb-2">
                    <div className="col-md">
                      <label htmlFor="challan_no">Challan No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="challan_no"
                        value={formInputs.challan_no}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="customer_name">Customer Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="customer_name"
                        value={formInputs.customer_name}
                        onChange={handleInputs}
                      />
                    </div>
                    {/* <DateRangeFilter
                      filterDate={filterDate}
                      onChange={handleInputDate}
                    /> */}
                    <div className="col-md">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="from_date"
                        value={formInputs.from_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="to_date"
                        value={formInputs.to_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="payment_mode_id">Payment Mode</label>
                      <select
                        className="form-select"
                        id="payment_mode_id"
                        name="payment_mode_id"
                        value={formInputs.payment_mode_id}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            payment_mode_id: e.target.value,
                          })
                        }
                      >
                        <option value={""}>select...</option>
                        {config?.paymentMode.map((v, i) => (
                          <option key={i} value={v.value}>
                            {v.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md">
                      <label htmlFor="is_zero_value">Zero Valued</label>
                      <select
                        className="form-select"
                        id="is_zero_value"
                        name="is_zero_value"
                        value={formInputs.is_zero_value}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_zero_value: e.target.value,
                          })
                        }
                      >
                        <option value="">All</option>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                    {user.role_id != 3 && user.role_id != 4 && (
                      <div className="col-md">
                        <label htmlFor="branch_id">Branch</label>
                        <select
                          className="form-select"
                          id="branch_id"
                          name="branch_id"
                          value={formInputs.branch_id}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              branch_id: e.target.value,
                            })
                          }
                        >
                          <option value={""}>select...</option>
                          {props.branchList.map((v, i) => (
                            <option key={i} value={v.value}>
                              {v.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="col-md">
                      <label htmlFor="is_active">Status</label>
                      <select
                        className="form-select"
                        id="is_active"
                        name="is_active"
                        value={formInputs.is_active}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_active: e.target.value,
                          })
                        }
                      >
                        {[
                          { id: "", name: "All" },
                          { id: 1, name: "New" },
                          { id: 2, name: "Partial Done" },
                          { id: 3, name: "Freeze" },
                          { id: 4, name: "Issued" },
                          { id: 5, name: "Cancelled" },
                          { id: 6, name: "Disputed" },
                        ].map((v, i) => (
                          <option
                            key={i}
                            value={v.id}
                            className={v.id === 0 ? "bg-lightgrey" : ""}
                          >
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div
                      className="col-md"
                      style={{ display: "flex", alignItems: "end" }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2 text-white"
                        type="reset"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          setFilterDate();
                          setExportIds([]);
                          document.getElementById("All").checked = false;
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          background: "#4263eb",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Clear Filters
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary py-0 ms-2"
                        style={{
                          background: "#4263eb",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#ffffff",
                        }}
                        onClick={downloadExportJson}
                      >
                        {isExport && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Export
                      </button>
                    </div>
                  </div>
                </form>
              )}

              <div className="mt-3">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <NavLink
                      to="/challan"
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      Challan
                    </NavLink>
                  </li>

                  <li className="nav-item">
                    <NavLink
                      to="/temp-challan"
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      Pending Challan
                    </NavLink>
                  </li>
                </ul>
              </div>

              {(error || success) && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-${
                        error ? "danger" : "success"
                      } py-1 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col table-responsive-lg">
                  <table
                    className={`table ${
                      error || success ? "my-1" : "mt-4"
                    } rounded`}
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            id="All"
                            value="All"
                            onChange={(e) => getExportIds(e)}
                          />
                        </th>
                        <th>Challan No</th>
                        <th>Customer Name</th>
                        {user.role_id != 3 && user.role_id != 4 && (
                          <th>Branch Name</th>
                        )}
                        <th className="text-end">Amount</th>
                        <th>Challan Date</th>
                        <th className="text-end">Export Count</th>
                        <th>Payment Mode</th>
                        <th>Zero Valued</th>
                        <th>Narration</th>
                        <th>Status</th>
                        <th style={{ width: "150px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length === 0) && (
                        <tr>
                          <td colSpan="10" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list &&
                        list.map((v, i) => (
                          <>
                            <tr
                              key={`sl_` + i}
                              className={
                                v?.export_count > 0
                                  ? ""
                                  : v.is_active === 5
                                    ? "bg-lightgrey"
                                    : v?.is_edited == 1
                                      ? "bg-warning-subtle"
                                      : ""
                              }
                              style={
                                v?.export_count > 0
                                  ? {
                                      backgroundColor: `rgba(var(--theme-btn-color-rgb, 13, 202, 240), ${Math.min(
                                        v?.export_count * 0.15,
                                        1
                                      )})`,
                                    }
                                  : v?.is_edited == 1 && v?.is_active !== 5
                                    ? {
                                      backgroundColor: "#fff3cd",
                                    }
                                    : {}
                              }
                            >
                              <td>
                                {v?.is_zero_value == 0 && (
                                  <input
                                    type="checkbox"
                                    value={v?.challan_id}
                                    checked={exportIds.includes(v?.challan_id)}
                                    className={
                                      moment(v.challan_date).format(
                                        "MM-DD-YY"
                                      ) >= moment().format("MM-DD-YY") &&
                                      [1, 2, 3, 5, 6].includes(v?.is_active)
                                        ? "d-none"
                                        : ""
                                    }
                                    onChange={(e) => getExportIds(e)}
                                  />
                                )}
                              </td>
                              <td>
                                <span>
                                  {v.challan_no}
                                  {v?.is_edited == 1 && (
                                    <Tippy content="Edited Challan">
                                      <span
                                        className="badge bg-warning text-dark ms-1"
                                        style={{ fontSize: "10px", verticalAlign: "middle" }}
                                      >
                                        Edited
                                      </span>
                                    </Tippy>
                                  )}
                                </span>
                              </td>
                              <td>
                                <span title={v.mst_cust.customer_name}>
                                  {v.mst_cust.customer_name.length > 15
                                    ? v.mst_cust.customer_name
                                        .toString()
                                        .substring(0, 15) + "..."
                                    : v.mst_cust.customer_name}
                                </span>
                              </td>
                              {user.role_id != 3 && user.role_id != 4 && (
                                <td>{v?.mst_branch?.branch_name}</td>
                              )}
                              <td className="text-end">
                                {millionComma(v.total_amount)}

                                {/* {parseFloat(v?.total_amount || 0).toFixed(2)} */}
                              </td>
                              <td>
                                {Moment(v.challan_date, "YYYY-MM-DD").format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td className="text-end">
                                {v?.export_count || "0"}
                              </td>
                              {/* <td className="text-end">
                                {v?.export_count || "0"}
                              </td> */}
                              <td>
                                {config?.paymentMode &&
                                  config?.paymentMode.find(
                                    (ele, ind) =>
                                      ele.value == v?.payment_mode_id
                                  )?.label}
                              </td>
                              <td>
                                {v?.is_zero_value == 1
                                  ? "Yes"
                                  : v?.is_zero_value == 0
                                  ? "No"
                                  : "NA"}
                              </td>
                              <td>
                                <Tippy content={`${v?.narration}`}>
                                  <span>
                                    {v?.narration?.length > 10
                                      ? v?.narration?.substring(0, 10) + "..."
                                      : v?.narration}
                                  </span>
                                </Tippy>
                              </td>

                              <td className="">{formatStatusBadge(v)}</td>
                              <td>
                                <Tippy content="View">
                                  <Link
                                    to={`/challan/view/` + v.challan_id}
                                    state={{
                                      sale: v,
                                      is_temp: true,
                                      currentPageNo: currentPage,
                                      currentFilter: formInputs,
                                      showFilter: filtersVisible,
                                      pageSize: userCount,
                                    }}
                                    className={`link-info me-2`}
                                  >
                                    <img
                                      src={viewIcon}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </Link>
                                </Tippy>
                                {v.is_active !== 5 && (
                                  /*<Tippy content="Print">
                                                                      <a
                                                                        href={
                                                                          v?.pdf_url ||
                                                                          `http://172.105.42.161:3015/pdf/${v.challan_id}.pdf`
                                                                        }
                                                                        className="me-2"
                                                                        target="_blank"
                                                                      >
                                                                        <img
                                                                          src={printIcon}
                                                                          className="img-fluid"
                                                                          alt=""
                                                                        />
                                                                      </a>
                                                                                                  </Tippy>*/
                                  <Tippy content="Print">
                                    {/*<img
                                                                        onClick={(e) =>
                                                                            printPrinter(v?.challan_id)
                                                                        }
                                                                        src={printIcon}
                                                                        className="img-fluid me-1"
                                                                        alt=""
                                                                        role="button"
                                                                    />*/}
                                    {/* <div className="dropdown d-inline-block">
                                      <div
                                        className="dropdown-toggle me-1"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                      >
                                        <img
                                          src={printIcon}
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <ul className="dropdown-menu">
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={(e) =>
                                              printPrinter(
                                                v?.challan_id,
                                                "_price",
                                                setShowPageLoader
                                              )
                                            }
                                          >
                                            Price
                                          </button>
                                        </li>
                                        {noPricePrint == 1 ? (
                                          <li>
                                            <button
                                              className="dropdown-item"
                                              onClick={(e) =>
                                                printPrinter(
                                                  v?.challan_id,
                                                  "",
                                                  setShowPageLoader
                                                )
                                              }
                                            >
                                              No Price
                                            </button>
                                          </li>
                                        ) : null}
                                      </ul>
                                    </div> */}
                                  </Tippy>
                                )}

                                {user?.role_id !== 2 &&
                                  user?.role_id !== 7 &&
                                  user?.role_id !== 8 &&
                                  user?.role_id !== 9 && (
                                    <>
                                      {moment(v.challan_date).isSameOrAfter(
                                        moment(userBackDate()),
                                        "day"
                                      ) &&
                                        (v.is_active === 1 ||
                                          v.is_active === 2) && (
                                          <Tippy content="Edit">
                                            <Link
                                              to={
                                                `/challan/edit/` + v.challan_id
                                              }
                                              state={{
                                                sale: v,
                                                is_temp: true,
                                                currentPageNo: currentPage,
                                                currentFilter: formInputs,
                                                showFilter: filtersVisible,
                                                pageSize: userCount,
                                              }}
                                              className={`link-info me-2`}
                                            >
                                              <img
                                                src={editIcon}
                                                className="img-fluid"
                                                alt=""
                                              />
                                            </Link>
                                          </Tippy>
                                        )}
                                      {moment(v.challan_date).format(
                                        "MM-DD-yy"
                                      ) >= moment().format("MM-DD-yy") &&
                                        v.is_active === 1 && (
                                          <Tippy content="Cancel">
                                            <a
                                              href="#cancel"
                                              onClick={(e) =>
                                                changeStatus(v.challan_id, 5)
                                              }
                                              className={`link-info`}
                                            >
                                              <img
                                                src={deleteIcon}
                                                className="img-fluid me-2"
                                                alt=""
                                              />
                                            </a>
                                          </Tippy>
                                        )}
                                      {moment(v.challan_date).format(
                                        "MM-DD-yy"
                                      ) >= moment().format("MM-DD-yy") &&
                                        v.is_active === 1 && (
                                          <Tippy content="Convert">
                                            <a
                                              href="#convert"
                                              onClick={(e) =>
                                                convertStatus(v.challan_id)
                                              }
                                              className={`link-info`}
                                            >
                                              <FaShare
                                                size={16}
                                                className="resend-action-icon me-2"
                                                style={{
                                                  color: "var(--theme-btn-color, #4263eb)",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </a>
                                          </Tippy>
                                        )}
                                    </>
                                  )}
                                {/* {user?.role_id !== 2 && (
                                  <>
                                    {v.is_active === 3 && (
                                      <Tippy content="Un-Freeze">
                                        <a
                                          href="#unfreeze"
                                          onClick={(e) =>
                                            changeStatus(v.challan_id, 3)
                                          }
                                          className={`link-info`}
                                        >
                                          {frezzLoader == v.challan_id ? (
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                          ) : (
                                            <img
                                              src={resendIcon}
                                              className="img-fluid me-2"
                                              alt=""
                                            />
                                          )}
                                        </a>
                                      </Tippy>
                                    )}
                                  </>
                                )} */}
                              </td>
                            </tr>
                            <tr
                              key={`sli_` + i}
                              id={`sli_` + i}
                              className="d-none"
                            >
                              <td colSpan="8">
                                <div className="table-responsive">
                                  <table className="table table-sm table-bordered ms-auto w-50 py-0 mb-0">
                                    <thead>
                                      <tr style={{ textAlign: "center" }}>
                                        <th>#</th>
                                        <th>Item Name</th>
                                        <th>Rate</th>
                                        <th>Reqd. Qty</th>
                                        <th>Supp. Qty</th>
                                        <th>Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {v?.item_dtl &&
                                        v.item_dtl?.map((v, i) => (
                                          <tr key={`slil_` + i}>
                                            <td>{i + 1}</td>
                                            <td>{v?.mst_item?.item_name}</td>
                                            <td className="text-end">
                                              {millionComma(v.rate)}
                                            </td>
                                            <td className="text-end">
                                              {parseFloat(
                                                v?.requested_qty || 0
                                              ).toFixed(2)}
                                            </td>
                                            <td className="text-end">
                                              {parseFloat(
                                                v?.received_qty || 0
                                              ).toFixed(2)}
                                            </td>
                                            <td className="text-end">
                                              {millionComma(
                                                v?.rate * v?.requested_qty
                                              ) || millionComma(v?.amount)}
                                            </td>
                                          </tr>
                                        ))}

                                      <tr>
                                        <td
                                          colSpan="5"
                                          className="text-end pe-2 fw-bold"
                                        >
                                          Gross Total
                                        </td>
                                        <td className="fw-bold text-end">
                                          {formatAmountChallan(v)}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / userCount)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default TempSalesList;
